import React from 'react';
import StaffLayout from '@/layouts/StaffLayout';
import ThemeWrapper from '@/components/ThemeWrapper';
import useInertiaData from '@/hooks/useInertiaData';

interface DashboardProps {
    title: string;
}

const DashboardContent: React.FC<DashboardProps> = ({ title }) => {
    const { user } = useInertiaData();

    return (
        <StaffLayout>
            <div className="mx-auto max-w-7xl">
                <div className="mb-8">
                    <h1 className="text-3xl font-bold text-gray-900">
                        {title}
                    </h1>
                    <p className="mt-2 text-gray-600">
                        Bienvenido, {user?.full_name}
                    </p>
                </div>

                <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
                    {/* Placeholder cards for future metrics */}
                    <div className="rounded-lg bg-white p-6 shadow">
                        <h3 className="text-lg font-semibold text-gray-900">
                            Panel de Staff
                        </h3>
                        <p className="mt-2 text-gray-600">
                            Gestiona usuarios comerciales y operaciones del staff.
                        </p>
                    </div>
                </div>
            </div>
        </StaffLayout>
    );
};

const Dashboard: React.FC<DashboardProps> = (props) => {
    return (
        <ThemeWrapper>
            <DashboardContent {...props} />
        </ThemeWrapper>
    );
};

export default Dashboard;
